import produce from 'immer';
import { MzMap } from 'module/Model/MzMap';
import { ReadOnly } from 'module/Common';

export type MzImmutableMap<K, V> = ReadOnly<MzMap<K, V>>;

export namespace MzImmutableMap {
  const empty: MzImmutableMap<any, any> = {
    keys: [],
    values: [],
  };

  const mutations: Array<MzImmutableMap<any, any>> = [];

  export function create<K, V>(): MzImmutableMap<K, V> {
    return empty;
  }

  export const get = MzMap.get;
  export const has = MzMap.has;
  export const forEach = MzMap.forEach;

  export function set<K, V>(model: MzImmutableMap<K, V>, key: K, value: V): MzImmutableMap<K, V> {
    return mutationSwitch(model, m => MzMap.set(m, key, value));
  }

  export function update<K, V>(
    model: MzImmutableMap<K, V>,
    key: K,
    updater: (value: V) => V,
    notSetValue: V
  ): MzImmutableMap<K, V> {
    return mutationSwitch(model, m => MzMap.update(m, key, updater, notSetValue));
  }

  export function updateIfExist<K, V>(
    model: MzImmutableMap<K, V>,
    key: K,
    updater: (value: V) => V
  ): MzImmutableMap<K, V> {
    return mutationSwitch(model, m => MzMap.updateIfExist(m, key, updater));
  }

  function isMutating<K, V>(draft: MzImmutableMap<K, V>): boolean {
    return mutations.indexOf(draft) >= 0;
  }

  export function withMutations<K, V>(
    model: MzImmutableMap<K, V>,
    updater: (model: MzImmutableMap<K, V>) => void
  ): MzImmutableMap<K, V> {
    return produce(model, draft => {
      mutations.push(draft);
      updater(draft);
      mutations.splice(mutations.indexOf(draft), 1);
    });
  }

  function mutationSwitch<K, V>(
    model: MzImmutableMap<K, V>,
    mutation: (model: MzImmutableMap<K, V>) => void
  ): MzImmutableMap<K, V> {
    if (isMutating(model)) {
      mutation(model);
      return model;
    }
    return produce(model, draft => {
      mutation(draft);
    });
  }
}



// WEBPACK FOOTER //
// ./src/module/Model/MzImmutableMap/index.ts